import React from 'react'

const HistoryIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <path
        fill={color}
        d="M138.5 2C91.3 12.2 55.6 49.2 47.4 96.1c-2.2 12.8-1.5 35.9 1.5 47.9 11.2 44.1 45.7 77.1 90.6 86.5 10 2.1 32.1 2.4 42.5.6 36.9-6.6 68.1-30 84.5-63.5 6.7-13.7 9.9-24.7 11.5-39.7 3.7-34.3-8.9-69.7-33.5-94.3-15.5-15.4-33-25.2-54.8-30.7-12.2-3.1-38.8-3.6-51.2-.9zm37.9 24.5c35.5 6.2 63 30.6 73.1 65 3.2 10.9 4.3 27.3 2.6 38.5-5.6 35.7-33.1 65.4-69.1 74.6-5.8 1.5-10.8 1.9-22 1.8-12.7-.1-15.6-.4-23.5-2.8-36.1-10.9-61.2-40.8-65.6-78.1-1.9-16.2 1.2-33.6 8.7-48.9 17.9-36.1 57.4-56.8 95.8-50.1z"
      />
      <path
        fill={color}
        d="M155.9 44.5c-1.4.8-3.5 2.7-4.5 4.2-1.8 2.6-1.9 5.1-1.9 37.3 0 32.9.1 34.6 2 37.2 4.2 5.7 4.9 5.8 45.5 5.8s41.9-.2 45.6-5.8c2.5-3.7 2.4-10.4-.2-13.9-4.4-6-6-6.3-38.1-6.3h-29.2l-.3-26.6-.3-26.6-3.7-3.4c-3.1-2.8-4.5-3.4-8-3.4-2.4.1-5.5.7-6.9 1.5zM289 81.4c0 .3.9 4.2 2 8.8 1.1 4.6 2.3 12.7 2.6 18l.7 9.7 62.6.3c69.1.3 65.6 0 69.8 6.5 1.7 2.6 1.8 11.9 1.8 171.8s-.1 169.2-1.8 171.8c-.9 1.5-2.9 3.5-4.4 4.4-2.6 1.7-9.6 1.8-118.3 1.8-113.9 0-115.5 0-118.2-2-6.1-4.5-5.8 1.9-5.8-116.8V247.3l-13.7.1c-7.6 0-16.2-.3-19.1-.7l-5.2-.8.2 113.3.3 113.3 2.3 5.9c6.2 16.3 17.8 27.5 33.4 32 5.1 1.4 17.5 1.6 126.5 1.6 115.7 0 121.2-.1 126.4-1.9 8.7-3 13.3-5.7 19.6-11.5 6.3-5.8 10.2-12 13.3-21.2 2-5.6 2-9.5 2-180.4 0-191.3.4-178.4-5.7-190.5-3.3-6.4-13.4-16.5-19.8-19.8-11.6-5.8-9.9-5.7-83.7-5.7-37.3 0-67.8.2-67.8.4z"
      />
      <path
        fill={color}
        d="M233.9 229.7c-7.9 4.9-7.8 17 .1 21.7 2.5 1.4 9.9 1.6 74 1.6h71.2l3.3-3.3c1.9-1.9 3.7-4.7 4.1-6.2 1.1-4.3-1.5-10.5-5.5-13.2l-3.4-2.3h-70.6c-63.5.1-70.9.2-73.2 1.7zM233.8 304.8c-5.6 3.4-7.3 11.2-3.8 16.9 4 6.6.7 6.3 77.7 6.3 67.5 0 69.9-.1 73-2 5.8-3.5 7.8-10.1 4.8-16.4-3.3-6.9.5-6.6-78.2-6.6-64.9.1-71 .2-73.5 1.8zM235.3 381.6c-9.5 4.7-9.5 18.2 0 22.7 3.2 1.5 10.1 1.7 72.2 1.7s69-.2 72.2-1.7c6.8-3.2 9.3-11.4 5.3-17.8-4.2-6.7-1.4-6.5-77.7-6.5-61 0-69.2.2-72 1.6z"
      />
    </svg>
  )
}

HistoryIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default HistoryIcon
